import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CloneService } from 'src/app/services/clone.service';
import { FactorSet, factorSetNaming } from 'src/app/models/FactorSet.model';
import { SimplicityLuggageAccommodation } from 'src/app/models/SimplicityLuggageAccommodation.model';
import { SimplicityLuggageAccommodationFactor } from 'src/app/models/SimplicityLuggageAccommodationFactor.model';
import { FactorSetData } from 'src/app/models/FactorSetData.model';
import { GridData } from 'src/app/matrix-component/grid-list/gridData.model';
import { IdValue } from 'src/app/matrix-component/grid-list/idvalue.model';

@Component({
  selector: 'app-simplicity-luggage-accommodation-factor',
  templateUrl: './simplicity-luggage-accommodation-factor.component.html',
  styleUrls: ['./simplicity-luggage-accommodation-factor.component.scss']
})
export class SimplicityLuggageAccommodationFactorComponent implements OnInit {

  constructor(private _formBuilder: FormBuilder,private cloneService:CloneService) { }


  ngOnInit() {
    this.form = this.parentForm;
    this.form.addControl('simplicityLuggageAccommodation', this._formBuilder.array([]));
    this.form.setControl('simplicityLuggageAccommodation', this.asFormGroup(this.data));
    this.lascCtrl = this.form.get('simplicityLuggageAccommodation');
    this.lascCtrl= this.lascCtrl.get('values');
    this.data.values =  this.lascCtrl.value as FactorSet[];
    this.gridData=this.ConvertData(this.data.values);
  }
  asFormGroup(o: SimplicityLuggageAccommodation): FormGroup {
    const fg = new FormGroup({
      id: new FormControl(o.id, Validators.required),
      regionId: new FormControl(o.regionId, Validators.required),
      values: new FormControl(o.values, Validators.required)
    });
    return fg;
  }
  @Input('form') parentForm: FormGroup;
  @Input('data') data: SimplicityLuggageAccommodation;
  @Input('isEditable') isEditable: boolean;
  @Input('simplicityLuggageAccommodationFactor') simplicityLuggageAccommodationFactor: SimplicityLuggageAccommodationFactor[];
  form: FormGroup;
  lascCtrl;
  matrix: FactorSetData[] = [];
  gridData: GridData=new GridData();

  ConvertData(values): GridData {
    for (let i = 0; i < values.length; i++) {
      const element = values[i];
      if(element.transportModeId===3)
      {
        let tmpData: FactorSetData = new FactorSetData();
        tmpData.colId=1;
        tmpData.rowId=element.additionalId;
        tmpData.value=element.deboardingValue;
        tmpData.factorSetId=element.id;
        this.matrix.push(tmpData);
        let tmpData2: FactorSetData = new FactorSetData();
        tmpData2.colId=2;
        tmpData2.rowId=element.additionalId;
        tmpData2.value=element.boarding1Value;
        tmpData2.factorSetId=element.id;
        this.matrix.push(tmpData2);
        let tmpData3: FactorSetData = new FactorSetData();
        tmpData3.colId=3;
        tmpData3.rowId=element.additionalId;
        tmpData3.value=element.boarding2Value;
        tmpData3.factorSetId=element.id;
        this.matrix.push(tmpData3);
      } 
      if(element.transportModeId===2)
      {
        let tmpData: FactorSetData = new FactorSetData();
        tmpData.colId=4;
        tmpData.rowId=element.additionalId;
        tmpData.value=element.deboardingValue;
        tmpData.factorSetId=element.id;
        this.matrix.push(tmpData);
        let tmpData2: FactorSetData = new FactorSetData();
        tmpData2.colId=5;
        tmpData2.rowId=element.additionalId;
        tmpData2.value=element.boarding1Value;
        tmpData2.factorSetId=element.id;
        this.matrix.push(tmpData2);
        let tmpData3: FactorSetData = new FactorSetData();
        tmpData3.colId=6;
        tmpData3.rowId=element.additionalId;
        tmpData3.value=element.boarding2Value;
        tmpData3.factorSetId=element.id;
        this.matrix.push(tmpData3);
      } 
      if(element.transportModeId===1)
      {
        let tmpData: FactorSetData = new FactorSetData();
        tmpData.colId=7;
        tmpData.rowId=element.additionalId;
        tmpData.value=element.deboardingValue;
        tmpData.factorSetId=element.id;
        this.matrix.push(tmpData);
        let tmpData2: FactorSetData = new FactorSetData();
        tmpData2.colId=8;
        tmpData2.rowId=element.additionalId;
        tmpData2.value=element.boarding1Value;
        tmpData2.factorSetId=element.id;
        this.matrix.push(tmpData2);
        let tmpData3: FactorSetData = new FactorSetData();
        tmpData3.colId=9;
        tmpData3.rowId=element.additionalId;
        tmpData3.value=element.boarding2Value;
        tmpData3.factorSetId=element.id;
        this.matrix.push(tmpData3);
      } 
    }


    let rowHeaders: IdValue[] = [];
    for (let i = 0; i < this.simplicityLuggageAccommodationFactor.length; i++) {
      const headerEntry =  this.simplicityLuggageAccommodationFactor[i];
      rowHeaders.push(new IdValue(headerEntry.id,headerEntry.name));
    }

    let colHeaders: IdValue[] = [];
    for (let i = 0; i < factorSetNaming.length; i++) {
      const headerEntry = factorSetNaming[i];
      colHeaders.push(new IdValue(headerEntry.id,headerEntry.name));
    }
    let grid: GridData = new GridData();
    grid.colHeaders = colHeaders;
    grid.rowHeaders = rowHeaders;
    grid.matrix = this.matrix.sort((a, b) => a.colId - b.colId).sort((a, b) => a.rowId - b.rowId);
    grid.colProp = 'colId';
    grid.rowProp = 'rowId';
    grid.switchColWithRow = false;
    return grid;
  }
  normalize(data: FactorSetData[]) {
    let tmp:FactorSet[] = [];
    let tmpFV:FactorSetData[] = data.filter(f=>f.colId > 0 && f.colId < 4);
    let tmpNV:FactorSetData[] = data.filter(f=>f.colId > 3 && f.colId < 7);
    let tmpUNV:FactorSetData[] = data.filter(f=>f.colId > 6 && f.colId < 10);


    for (let i = 0; i < this.simplicityLuggageAccommodationFactor.length; i++) {
      const elementAisle = this.simplicityLuggageAccommodationFactor[i];

      let tmp1:FactorSet = new FactorSet;
      tmp1.transportModeId=3;
      for (let i = 0; i < tmpFV.length; i++) {
        const element = tmpFV[i];
        if(element.colId==1 && element.rowId==elementAisle.id)
        {
          tmp1.deboardingValue=element.value
          tmp1.additionalId = element.rowId;
          tmp1.id=element.factorSetId;
        }
        else if(element.colId==2 && element.rowId==elementAisle.id)
        {
          tmp1.boarding1Value=element.value
          tmp1.additionalId = element.rowId;
          tmp1.id=element.factorSetId;

        }
        else if(element.colId==3 && element.rowId==elementAisle.id)
        {
          tmp1.boarding2Value=element.value
          tmp1.additionalId = element.rowId;
          tmp1.id=element.factorSetId;

        }
      }
      tmp.push(tmp1);
  
      let tmp2:FactorSet = new FactorSet;
      tmp2.transportModeId=2;
  
      for (let i = 0; i < tmpNV.length; i++) {
        const element = tmpNV[i];
        if(element.colId==4 && element.rowId==elementAisle.id)
        {
          tmp2.deboardingValue=element.value
          tmp2.additionalId = element.rowId;
          tmp2.id=element.factorSetId;

        }
        else if(element.colId==5 && element.rowId==elementAisle.id)
        {
          tmp2.boarding1Value=element.value
          tmp2.additionalId = element.rowId;
          tmp2.id=element.factorSetId;

        }
        else if(element.colId==6 && element.rowId==elementAisle.id)
        {
          tmp2.boarding2Value=element.value
          tmp2.additionalId = element.rowId;
          tmp2.id=element.factorSetId;

        }
      }
      tmp.push(tmp2);
      
  
      let tmp3:FactorSet = new FactorSet;
      tmp3.transportModeId=1;
      for (let i = 0; i < tmpUNV.length; i++) {
        const element = tmpUNV[i];
        if(element.colId==7 && element.rowId==elementAisle.id)
        {
          tmp3.deboardingValue=element.value
          tmp3.additionalId = element.rowId;
          tmp3.id=element.factorSetId;

        }
        else if(element.colId==8 && element.rowId==elementAisle.id)
        {
          tmp3.boarding1Value=element.value
          tmp3.additionalId = element.rowId;
          tmp3.id=element.factorSetId;

        }
        else if(element.colId==9 && element.rowId==elementAisle.id)
        {
          tmp3.boarding2Value=element.value
          tmp3.additionalId = element.rowId;
          tmp3.id=element.factorSetId;

        }
      }
      tmp.push(tmp3);
    }
    this.data.values=tmp;
  }
  save()
  {
    let clonedGridData = this.cloneService.deepClone(this.gridData.matrix) as FactorSetData[];
    this.normalize(clonedGridData);

    if(this.lascCtrl !== null)
    {
      this.lascCtrl.patchValue(this.data.values);
    }
  }
}
